"use client";

import React, { useEffect, useRef, useState } from "react";

export default function NavWrapper({
  children,
  drawerOpen,
  sticky,
  setSticky,
}) {
  const headerRef = useRef(null);

  useEffect(() => {
    if (drawerOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [drawerOpen]);

  // handle scroll event
  const handleScroll = (elTopOffset, elHeight) => {
    if (window.scrollY > elTopOffset + elHeight) {
      setSticky({ isSticky: true, offset: elHeight });
    } else {
      setSticky({ isSticky: false, offset: 0 });
    }
  };
  // add/remove scroll event listener
  useEffect(() => {
    var header = headerRef.current.getBoundingClientRect();
    const handleScrollEvent = () => {
      handleScroll(header.top, header.height);
    };

    window.addEventListener("scroll", handleScrollEvent);

    return () => {
      window.removeEventListener("scroll", handleScrollEvent);
    };
  }, []);

  return (
    <div
      className={`w-full mx-auto z-[10000] text-black shadow-md  lg:shadow-none min-h-[74px]   ${
        sticky.isSticky
          ? "fixed duration-1000 backdrop-blur-lg bg-slate-50 "
          : "static duration-500  bg-white "
      }`}
      ref={headerRef}
    >
      {children}
    </div>
  );
}
